import { useTheme } from '@mui/material';

export const TryAgainIcon = () => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
    } = theme.colors.other.icon;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} fill="none">
            <path
                fill={primaryStroke}
                d="M37 20h1V10h-2v6.788C33.55 12.718 29.094 10 24 10c-7.731 0-14 6.269-14 14s6.269 14 14 14c5.4 0 10.087-3.063 12.425-7.538l-1.775-.924C32.644 33.38 28.631 36 24 36c-6.625 0-12-5.375-12-12s5.375-12 12-12c4.438 0 8.319 2.412 10.394 6H28v2h9Z"
            />
        </svg>
    );
};
